import { getURLParameters } from '../../../lib/utilities';
export const setFlagTo = (stores, flagName) => {
    const TYROOLA = window.TYROOLA || {};
    const parameters = getURLParameters(location.search);
    const hasParam = (flagName in parameters);
    const isActivated = typeof stores === 'object'
        ? TYROOLA.globals && stores[TYROOLA.globals.store] || false
        : !!stores;

    return hasParam
        ? parameters[flagName] === '1'
        : isActivated;
};
